import { render, staticRenderFns } from "./ProjectRange.vue?vue&type=template&id=5cb4528f&scoped=true"
import script from "./ProjectRange.vue?vue&type=script&lang=js"
export * from "./ProjectRange.vue?vue&type=script&lang=js"
import style0 from "./ProjectRange.vue?vue&type=style&index=0&id=5cb4528f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb4528f",
  null
  
)

export default component.exports